/**
 * Registers the 'sidebarQuestionlist' directive with the provided module.
 * This directive is used to render a sidebar containing a list of questions.
 * 
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerSidebarQuestionlistDirective(module) {
    module.directive('sidebarQuestionlist', function() {
        return {
            /**
             * Restricts the directive to be used as an element only.
             */
            restrict: 'E',
            /**
             * Determines whether the directive should replace the element it's attached to.
             * Currently set to false, meaning it will not replace the element.
             */
            replace: false,
            /**
             * Specifies the URL of the template to be used by the directive.
             */
            templateUrl: '/views/ib/modules/sidebar/SidebarQuestionlist.html',
            /**
             * Defines the scope for the directive.
             * task: '=' means it will two-way bind the 'task' attribute from the parent scope.
             */
            scope: {
                task: '='
            },
            /**
             * Specifies the controller to be associated with the directive.
             */
            controller: 'SidebarQuestionlistController'
        };
    });
}